import { inject, Injectable } from '@angular/core';
import { AuthenticatorService } from './authenticator.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, defer, first, map, of, shareReplay, switchMap, throwError } from 'rxjs';
import { Profile } from '../model/api';
import { ApiService } from './api.service';
import { IdSystemUserService } from './id-system';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private api = inject(ApiService)
  private authenticator = inject(AuthenticatorService)
  private idSystemUser = inject(IdSystemUserService)

  private profileRequest$ = defer(() => this.api.get<Profile>('/profile/get-profile').pipe(
    map(profile => {
      if (!profile.lang) {
        profile.lang = 'en'
      }
      if (!profile.timezone) {
        profile.timezone = 'UTC'
      }
      return profile
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status == 401) {
        return of(undefined)
      }
      return throwError(() => error)
    })
  ))

  private userRequest$ = defer(() => this.idSystemUser.getAccountDetail().pipe(
    map(user => {
      return user
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status == 401) {
        return of(undefined)
      }
      return throwError(() => error)
    })
  ))

  readonly profile$ = this.authenticator.auth$.pipe(
    switchMap(flag => flag ? this.profileRequest$ : of(undefined)),
    shareReplay(1)
  )

  readonly user$ = this.authenticator.auth$.pipe(
    switchMap(flag => flag ? this.userRequest$ : of(undefined)),
    shareReplay(1)
  )

  constructor() {
    this.profile$.subscribe()
    this.user$.subscribe()
  }

  getProfile() {
    return this.profile$.pipe(first())
  }

  getUser() {
    return this.user$.pipe(first())
  }
}
